import { Box, Image, Skeleton } from '@chakra-ui/react';
import React from 'react';
import { useEffect, useState } from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

import { useApi } from '@app/hooks';
import { SharedPhoto } from '@app/api/share';
import { PanZoomPicture } from '@app/components/common';

type ActivityGalleryProps = {
  photoHashes: string[] 
}

export const ActivityGallery = ({photoHashes}: ActivityGalleryProps) => {
  const [images, setImages] = useState<SharedPhoto[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const api = useApi();

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const response = await Promise.all(photoHashes.map(api.share.getPhotoShare));
      const _images = [];
      response.map((item) => {
        if (item.code === 200) {
          _images.push(item.data.photo);
        }
      });
      setImages(_images);
      setIsLoading(false);
    })();
  }, [photoHashes]);

  return <Box width='100%' height='410px'>
    {isLoading && <Box display='flex' justifyContent='center' alignItems='center'>
      <Skeleton
        variant="rect"
        width="100%"
        height="400px"
      />
    </Box>}
    {!isLoading && <Carousel
      responsive={{
        desktop: {
          breakpoint: { max: 3000, min: 1024 },
          items: 1,
          partialVisibilityGutter: 60
        },
        mobile: {
          breakpoint: { max: 464, min: 0 },
          items: 1,
          partialVisibilityGutter: 60
        },
        tablet: {
          breakpoint: { max: 1024, min: 464 },
          items: 1,
          partialVisibilityGutter: 60
        }
      }}
      autoPlay={false}
      swipeable={false}
    >
      {images.map((item, index) => <React.Fragment key={'image-' + item.filename + index}>
          <Box display='flex' justifyContent='center' alignItems='center' height='400px'>
            <PanZoomPicture  src={`data:jpg;base64,${item.content}`} alt={item.filename + index} />
          </Box>
        </React.Fragment>)}
    </Carousel>}
  </Box>;
};